import React, { useState } from "react";
import { footerLinks, CONTACT_NUMBER } from "../mock";
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Youtube, Linkedin, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { useToast } from "../hooks/use-toast";

const Footer = () => {
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({ title: "You're on the list!", description: `We'll send exclusive AIP offers to ${email}.` });
    setEmail("");
  };

  return (
    <footer className="bg-neutral-950 text-neutral-300">
      {/* Newsletter */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-serif font-medium text-white leading-tight">
              Get exclusive offers straight to your inbox
            </h3>
            <p className="text-neutral-400 mt-2 text-sm">Sign up for AIP news, offers and inspiration.</p>
          </div>
          <form onSubmit={subscribe} className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="flex-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-white placeholder:text-neutral-500 focus:outline-none focus:border-[#c8102e]"
            />
            <Button type="submit" className="bg-[#c8102e] hover:bg-[#a70d26] text-white rounded-none px-6 py-6 tracking-wide">
              Subscribe <ArrowRight size={14} className="ml-2" />
            </Button>
          </form>
        </div>
      </div>

      {/* Main */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-[#c8102e] flex items-center justify-center">
                <span className="text-white font-bold text-lg tracking-tight">A</span>
              </div>
              <div className="leading-tight">
                <div className="text-lg font-semibold text-white">AIP Booking</div>
                <div className="text-[10px] uppercase tracking-widest text-neutral-500">Hospitality Group</div>
              </div>
            </div>
            <p className="text-sm text-neutral-400 leading-relaxed mb-5">
              Discover more than 1,100 hotels across 95+ countries. Every stay, a rewarding experience.
            </p>
            <div className="space-y-2.5 text-sm">
              <a href={`tel:${CONTACT_NUMBER.replace(/\s/g, "")}`} className="flex items-center gap-2 text-neutral-300 hover:text-white transition-colors">
                <Phone size={14} className="text-[#c8102e]" /> {CONTACT_NUMBER}
              </a>
              <a href="mailto:reservations@aipbooking.com" className="flex items-center gap-2 text-neutral-300 hover:text-white transition-colors">
                <Mail size={14} className="text-[#c8102e]" /> reservations@aipbooking.com
              </a>
              <div className="flex items-start gap-2 text-neutral-400">
                <MapPin size={14} className="text-[#c8102e] mt-0.5" /> Global HQ · Mumbai, India
              </div>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, items]) => (
            <div key={title}>
              <h4 className="text-white font-medium mb-4 text-sm tracking-wide uppercase">{title}</h4>
              <ul className="space-y-2.5">
                {items.map((it) => (
                  <li key={it}>
                    <a href="#" className="text-sm text-neutral-400 hover:text-white transition-colors">{it}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div className="text-xs text-neutral-500">
            © {new Date().getFullYear()} AIP Booking Group. All rights reserved.
            <span className="mx-2">·</span>
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <span className="mx-2">·</span>
            <a href="#" className="hover:text-white">Terms of Use</a>
            <span className="mx-2">·</span>
            <a href="#" className="hover:text-white">Cookie Settings</a>
          </div>
          <div className="flex items-center gap-4">
            {[Facebook, Instagram, Twitter, Youtube, Linkedin].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 border border-white/15 flex items-center justify-center text-neutral-300 hover:text-white hover:border-[#c8102e] hover:bg-[#c8102e] transition-all">
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
